export const SliderData = [
    {
        src: 'https://quotefancy.com/media/wallpaper/1600x900/167850-John-C-Maxwell-Quote-The-truth-is-that-teamwork-is-at-the-heart-of.jpg',
    },
    {
        src: 'https://quotefancy.com/media/wallpaper/3840x2160/5521-Henry-Ford-Quote-If-everyone-is-moving-forward-together-then.jpg',
    },
    {
        src: 'https://quotefancy.com/media/wallpaper/3840x2160/81591-Michael-Jordan-Quote-There-is-no-i-in-team-but-there-is-in-win.jpg',
    },
]